import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-unauthorized',
  template: `
    <div class="flex flex-col items-center justify-center h-full mt-20">
      <h1 class="text-4xl font-bold text-red-500">403 - Unauthorized</h1>
      <p class="mt-4 text-xl">You do not have permission to view this page.</p>
      <button
        routerLink="/"
        class="px-4 py-2 mt-8 text-white bg-blue-600 rounded hover:bg-blue-700"
      >
        Go to Home
      </button>
    </div>
  `,
})
export class UnauthorizedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
